import React, { useCallback } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.secondary.main,
    },
    label: {
      padding: '0 5px',
      zIndex: 100,
      backgroundColor: '#f6f6f6',
      color: 'black !important',
      fontSize: 16,
      fontWeight: 'bold',
    },
  })
);

interface Item {
  /**
   *
   */
  id: string;

  /**
   *
   */
  label: string;
}

export interface CheckboxGroupFieldProps {
  /**
   * Name of input.
   */
  name: string;

  /**
   * Label of input.
   */
  label?: string;

  /**
   * Bool value of input.
   */
  value: string[];

  /**
   * Change handler.
   */
  onChange: (value: string[]) => void;

  /**
   *
   */
  items: Item[];
}

export function CheckboxGroupField({
  name,
  label,
  value = [],
  onChange,
  items,
}: CheckboxGroupFieldProps) {
  const classes = useStyles();

  /**
   *
   */
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let newArray = [];

      if (e.target.checked) {
        newArray = [...value, e.target.value];
      } else {
        newArray = [...value.filter((v) => v !== e.target.value)];
      }

      onChange(newArray);
    },
    [onChange, value]
  );

  return (
    <FormControl variant="outlined">
      <InputLabel classes={{ root: classes.label }} shrink>
        {label}
      </InputLabel>
      {items.map((item) => (
        <FormControlLabel
          key={item.id}
          control={
            <Checkbox
              className={classes.root}
              checked={!!value?.find((v) => v === item.id)}
              onChange={handleChange}
              value={item.id}
            />
          }
          label={item.label}
        />
      ))}
    </FormControl>
  );
}
